export default __webpack_public_path__ + "static/media/0_Still.01b05ca5.jpg";